import React from 'react';
import { useState, useEffect } from 'react';
import { auth, db } from '../firebase-config';
import { collection, doc, updateDoc, onSnapshot, query, where, orderBy } from 'firebase/firestore';

import { UserAuth } from '../context/AuthContext';
import UserRouter from '../pages/UserRouter'
import Tips from '../components/Tips';

const VerificationMessage = () => {
    const { user } = UserAuth(); // user credentials
    const [userID, setUserID] = useState(""); // user id
    const [userCollection, setUserCollection] = useState([]); // user collection

    // set user id
    useEffect(() => {
        if (user) {
        setUserID(user.uid)
        }
    }, [{ user }])

    // fetch user collection
    useEffect(() => {
        if (userID === undefined) {
            const userCollectionRef = collection(db, "user")
            const q = query(userCollectionRef, where("user", "==", "DONOTDELETE"));

            const unsub = onSnapshot(q, (snapshot) =>
                setUserCollection(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            );
            return unsub;
        }
        else {
            const userCollectionRef = collection(db, "user")
            const q = query(userCollectionRef, where("user", "==", userID));

            const unsub = onSnapshot(q, (snapshot) =>
                setUserCollection(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            );
            return unsub;
        }
    }, [userID])

    return (
        <div>
            <UserRouter
                route='/verify'
            />
            <Tips
                page='/verify'
            />
            <div id="verification-page" className="h-100">
                <div className="w-100 h-75 p-5 d-flex align-items-center justify-content-center">
                    <div id="contents" className="px-0 w-auto h-auto d-flex align-items-center justify-content-center">
                        <div id="add-border" className="d-flex align-items-center justify-content-center">
                            <div className="module-container my-5 d-flex align-items-center justify-content-center flex-column">
                                <h2 className="py-4">
                                    <strong>
                                        {userCollection === undefined?
                                            <></>
                                        :
                                            userCollection.map((user) => {
                                                return(
                                                    <>Hey, {(user.name).split(" ")[0]}</>
                                                )
                                            })
                                        }
                                    </strong>
                                </h2>
                                <h4 className="py-1">
                                    Your verification is underway.
                                </h4>
                                <br />
                                <h5 className="py-0">
                                    This should take 2-5 business days.
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerificationMessage; 
